export default {
  path: "/user/cpa/convivencia",
  component: () =>
    import("@/views/user/cpa/convivencia/ConvivenciaLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "convivencia-resumen",
      component: () =>
        import("@/views/user/cpa/convivencia/ResumenView.vue"),
    },
    {
      path: "encargados",
      name: "convivencia-encargados",
      component: () =>
        import("@/views/user/cpa/convivencia/EncargadosView.vue"),
    },
    {
      path: "postulaciones",
      name: "convivencia-postulaciones",
      component: () =>
        import("@/views/user/cpa/convivencia/PostulacionesView.vue"),
    },
    {
      path: "reuniones",
      name: "convivencia-reuniones",
      component: () =>
        import("@/views/user/cpa/convivencia/ReunionesView.vue"),
    },
    {
      path: "eventos/nuevo",
      name: "convivencia-evento-nuevo",
      component: () =>
        import("@/views/user/cpa/convivencia/EventoDetalleView.vue"),
    },
    {
      path: "eventos/:eventId",
      name: "convivencia-evento-detalle",
      component: () =>
        import("@/views/user/cpa/convivencia/EventoDetalleView.vue"),
      props: true,
    },
    {
      path: "comunicaciones",
      name: "convivencia-comunicaciones",
      component: () =>
        import("@/views/user/cpa/convivencia/ComunicacionesView.vue"),
    },
    {
      path: "configuracion",
      name: "convivencia-configuracion",
      component: () =>
        import("@/views/user/cpa/convivencia/ConfiguracionView.vue"),
    },
  ],
};
